import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MinusIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Minus`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M12 8H4"
      fill="none"
    />
  </Icon>
);
